<template>
  <div class="base-box">
    <van-field class="input-item" v-model="params.mobile" label="手机号" placeholder="请输入您的手机号码"></van-field>
    <van-field class="input-item" v-model="params.captcha" label="图片验证" clearable placeholder="请输入图片验证码">
      <div slot="button" @click="changeCode()">
        <img v-if="captchaImage" :src="captchaImage" class="chaImage" />
      </div>
    </van-field>
    <van-field class="input-item" v-model="params.code" label="验证码" clearable placeholder="请输入短信验证码">
      <van-button :disabled="isDisabled" slot="button" size="small" type="primary" @click="getCode">
        <template v-if="!isSpend">获取验证码</template>
        <template v-else>( {{time+'s后重新获取'}} )</template>
      </van-button>
    </van-field>
    <van-cell class="input-item" title="会员类型" :value="memberName" is-link
      @click="setSelectModel('memberTypeList', 'dueName', 'memberType')" />
    <van-field class="input-item" v-model="params.name" label="真实姓名" placeholder="请输入您的真实姓名"></van-field>
    <van-field class="input-item" v-model="params.company" label="工作单位" v-if="this.memberName!='学生会员'"
      placeholder="请输入工作单位"></van-field>
    <van-field class="input-item" :type="isShowPW ? 'password' : ''" label="密码"
      :right-icon="isShowPW ? 'closed-eye' : 'eye-o'" @click-right-icon="isShowPW = !isShowPW" v-model="params.password"
      placeholder="包含数字字符字母长度不小于8位"></van-field>
    <van-field class="input-item" :type="isShowPW2 ? 'password' : ''" label="确认密码"
      :right-icon="isShowPW2 ? 'closed-eye' : 'eye-o'" @click-right-icon="isShowPW2 = !isShowPW2"
      v-model="params.password2" placeholder="请再次输入您的登录密码"></van-field>
    <van-button class="successedBtn" type="primary" size="large" @click="submit">完成</van-button>
    <van-checkbox class="rule-box" checked-color="#1989fa" v-model="checked" icon-size="16px">
      我已阅读
      <span @click.stop="goHerf">《入会须知》</span>
    </van-checkbox>
    <!-- 入会须知 -->
    <el-dialog :visible.sync="show" title="入会须知" width="90%">
      <vanRule></vanRule>
    </el-dialog>
    <!-- 选择弹窗 -->
    <van-popup v-model="selectModel" position="bottom" :style="{ 'min-height': '20%' }">
      <template>
        <van-picker show-toolbar ref="picker" :value-key="key" :columns="columns" @change="onChange" @cancel="onCancel"
          @confirm="onConfirm" />
      </template>
    </van-popup>
  </div>
</template>

<script>
  import { Field, Button, Checkbox, Toast, Popup, Cell, CellGroup, Picker, Divider, Dialog } from "vant";
  import { fastRegisterMember, getRegisterCode, verifyRegisterCode, checkMobile, getCaptchaImage } from "@/api/login";
  import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
  import vanRule from "@/views/rule"
  export default {
    data() {
      return {
        time: 60,
        isSpend: false,
        isDisabled: false,
        params: {
          mobile: "",
          code: "",
          login: "",
          password: "",
          password2: "",
          memberCategory: 1,
          name: "",
          company: "",
          memberType: null,
          captcha: ''
        },
        captchaImage: null,
        checked: false,
        isShowPW: true,
        isShowPW2: true,
        beginClientX: 0 /*距离屏幕左端距离*/,
        mouseMoveStata: false /*触发拖动状态  判断*/,
        maxwidth: "" /*拖动最大宽度，依据滑块宽度算出来的*/,
        confirmWords: "请按住滑块，拖到最右边" /*滑块文字*/,
        confirmSuccess: false /*验证成功判断*/,
        selectModel: false,
        memberName: "",
        key: "",
        columns: [],
        value: 0,
        show: false
      };
    },
    components: {
      [Field.name]: Field,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [Popup.name]: Popup,
      [Cell.name]: Cell,
      [Picker.name]: Picker,
      [CellGroup.name]: CellGroup,
      [Divider.name]: Divider,
      [Dialog.name]: Dialog,
      vanRule

    },
    computed: {
      ...mapState(["memberTypeList"]),
    },
    created() {
      this.getCaptchaImageFunction()
    },
    methods: {
      ...mapActions(["getMemberTypeList"]),
      changeCode() {

      },
      changeCode() {
        this.getCaptchaImageFunction()
      },
      register() {
        let params = {
          mobile: this.params.mobile,
          code: this.params.code,
        }
        verifyRegisterCode(params).then(res => {
          if (res.success) {
            let params = this.params;
            params.device = 'mobile'
            params.memberCategory = 1;
            fastRegisterMember(params).then((res) => {
              console.log('params', params)
              if (res.success) {
                this.$emit("updateInfo", res.result);
                this.$emit("loginInfo", params);
                // this.$emit("sendActive", 2);
              } else {
                if (res.messageCode == "110001") {
                  Toast.fail("用户名已经存在!");
                  return;
                }
                if (res.messageCode == "110002") {
                  Toast.fail("手机号已经存在!");
                  return;
                }
                Toast.fail("注册失败!");
              }
            });
          } else {
            Toast("验证码不正确！");
          }
        });
      },
      // goHerf(){
      //   window.open("http://www.forestry.gov.cn/hhxh/268/20150731/985923.html","_blank");
      // },
      goHerf() {
        this.show = true
        // this.$router.push({ path: "/rule" });
      },
      async submit() {
        let isChecked = this.$regexp.password(this.params.password),
          loginName = this.$regexp.loginOnly(this.params.login),
          regexpPassword = this.$regexp.chinese(this.params.password);
        if (!this.params.mobile) {
          Toast("请输入手机号！");
          return;
        }

        if (!this.params.code) {
          Toast("请输入验证码！");
          return;
        }
        if (!this.params.memberType) {
          Toast("请选择会员类型！");
          return;
        }
        if (!this.params.name) {
          Toast("请输入真实姓名！");
          return;
        }

        // if (!loginName) {
        //   Toast("登录名只能是字母数字组合，不可纯数字或纯字母!");
        //   return;
        // }
        if (!this.params.password || !isChecked || regexpPassword) {
          Toast("密码必须包含数字、字符、字母长度不小于8位！");
          return;
        }
        if (this.params.password !== this.params.password2) {
          Toast("两次输入的密码不正确!");
          return;
        }
        if (!this.checked) {
          Toast("请阅读入会须知！");
          return;
        }
        this.register();
      },
      setSelectModel(type, key, selectKey) {
        this.selectModel = true;
        this.key = key;
        this.selectKey = selectKey;
        this.columns = this[type];
      },
      onChange(picker, values, index) {
        this.changeData = values;
      },
      onConfirm(item) {
        this.selectModel = false;
        if (this.selectKey === "memberType") {
          this.params.memberType = item.memberType;
          this.memberName = item.dueName;
        } else if (this.selectKey === "add") {
          this.params.province = item[0].value;
          this.params.city = item[1] ? item[1].value : "";
          this.addName = item[0].name + item[1] ? item[1].name : "";
        } else {
          this.params[this.selectKey] = item.value;
        }
      },
      onCancel() {
        this.selectModel = false;
      },
      getCaptchaImageFunction() {
        let captchaUuid = "";
        if (sessionStorage.getItem("captchaUuid")) {
          captchaUuid = sessionStorage.getItem("captchaUuid");
        } else {
          //生成captchaUuid
          let times = new Date().getTime();
          let numNo = Number(Math.random().toString().substr(2));
          captchaUuid = (times + numNo).toString(12);
          sessionStorage.setItem("captchaUuid", captchaUuid);
        }
        getCaptchaImage({ captchaUuid: captchaUuid }).then(res => {
          if (res.success) {
            this.$set(this, "captchaImage", res.result)
          } else {
            this.$message.error(res.message || "验证码生成失败");
          }
        })
      },
      async getCode() {
        let mobile = this.params.mobile;
        if (this.isSpend || this.params.mobile === 0) {
          return;
        }
        if (!this.$regexp.mobile(mobile)) {
          Toast("请输入正确的手机号");
          return false;
        }
        if (!this.params.captcha) {
          Toast("请输入图片验证码");
          return false;
        }
        await this.checkMobiles(this.params.mobile);
        //生成签名
        let timestamp = new Date().getTime();
        let data = "appSecretKey=captcha_codes&mobile=" + mobile + "&timestamp=" + timestamp;
        let sign = this.$md5(data);
        getRegisterCode({
          mobile: mobile,
          captchaUuid: sessionStorage.getItem("captchaUuid"),
          captcha: this.params.captcha,
          sign: sign,
          timestamp: timestamp
        }).then((res) => {
          if (res.success) {
            this.isSpend = true;
            this.time = 60;
            this.count();
          } else {
            Toast(res.message)
          }
        });
      },
      checkMobiles(mobile) {
        let params = {
          mobile
        };
        return new Promise((resolve, reject) => {
          checkMobile(params)
            .then(res => {
              if (!res.result && res.success) {
                resolve();
              } else {
                Toast("该手机号码已经注册过！");
              }
            })
            .catch(() => {
              Toast("该手机号码已经注册过！");
            });
        });
      },
      count() {
        --this.time;
        if (this.time > 0) {
          setTimeout(() => {
            this.count();
          }, 1000);
        } else {
          this.isSpend = false;
        }
      },
    },
    mounted() {
      this.params.memberCategory = this.$route.query.memberCategory;
      this.getMemberTypeList();
    },
  };
</script>

<style lang="less" scoped>
  /deep/.el-dialog__body {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 0 !important;
  }

  .input-item {
    padding: 0;
    padding-bottom: 12px;
    display: flex;
    align-items: center;

    i {
      color: #aaa;
    }

    &+.input-item {
      margin-top: 20px;
    }
  }

  /deep/.van-field__label {
    width: 2.2rem
  }

  .successedBtn {
    margin: 30px 0 25px 0 !important;
  }

  .rule-box {
    justify-content: center;
    margin-bottom: 20px;
  }

  .type_box {
    overflow: hidden;
    border-bottom: #dfdfdf solid 1px;
    margin-bottom: 30px;
    margin-top: -10px;
  }

  .type_box p {
    float: left;
    font-size: 15px;
    height: 50px;
    line-height: 50px;
    color: #333;
  }

  .chaImage {
    width: 90px;
    height: 30px;
    margin-left: 10px
  }
</style>